import { render, staticRenderFns } from "./reademail.vue?vue&type=template&id=6655163c&"
import script from "./reademail.vue?vue&type=script&lang=js&"
export * from "./reademail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports